import { httpGet, httpPost,httpGetForm } from '@/request';

//获取地图信息列表
function getIndexAll() {
    return httpGet("/cultural-tourism-map/app/map/index/all")
}
//首页-云游广水-住宿分页查询
function getHotelPage(params) {
    return httpPost("/cultural-tourism-map/app/map/hotel/page", params)
}
//首页-云游广水-活动分页查询
function getActivityPage(params) {
    return httpPost("/cultural-tourism-map/app/map/activity/page", params)
}
//首页-云游广水-景区分页查询
function getScenicspotPage(params) {
    return httpPost("/cultural-tourism-map/app/map/scenic-spot/page", params)
}
//首页-云游广水-餐饮分页查询
function getCateringPage(params) {
    return httpPost("/cultural-tourism-map/app/map/catering/page", params)
}
//首页-云游广水-城市地标景点分页查询
function getAttractionsPage(params) {
    return httpPost("/cultural-tourism-map/app/map/attractions-city/page", params)
}

// 首页-云游广水-住宿分页查询-住宿详情
function getHotelInfo(params) {
    return httpGet("/cultural-tourism-map/app/map/hotel/info",params)
}
// 首页-云游广水-城市地标景点分页查询-城市地标景点详情
function getAttractionsInfo(params) {
    return httpGet("/cultural-tourism-map/app/map/attractions-city/info",params)
}
// 首页-云游广水-景区分页列表-景区详情
function getScenicInfo(params) {
    return httpGet("/cultural-tourism-map/app/map/scenic-spot/info",params)
}
// 首页-云游广水-活动分页查询-活动详情
function geActivityInfo(params) {
    return httpGet("/cultural-tourism-map/app/map/activity/info",params)
}
// 首页-云游广水-餐饮分页查询-餐饮详情
function getCateringInfo(params) {
    return httpGet("/cultural-tourism-map/app/map/catering/info",params)
}
// 首页-云游广水-景区分页列表-景区详情-景点详情
function getAttractionsPointInfo(params) {
    return httpGet("/cultural-tourism-map/app/map/attractions/info",params)
}
// 首页-最新资讯-资讯分页查询
function getContentPage(params) {
    return httpPost("/cultural-tourism-content/app/content/news/page", params)
}
//查看资讯详情（无差别记录阅读量+1）
function getContentInfo(params) {
    return httpGet("/cultural-tourism-content/app/content/news/info",params)
}

// 首页最新滚动
function getNewsLast(params) {
    return httpGet("/cultural-tourism-content/app/content/news/last",params)
}

export {
    getContentInfo,
    getContentPage,
    getAttractionsPointInfo,
    geActivityInfo,
    getCateringInfo,
    getScenicInfo,
    getAttractionsInfo,
    getHotelInfo,
    getAttractionsPage,
    getCateringPage,
    getScenicspotPage,
    getActivityPage,
    getHotelPage,
    getIndexAll,
    getNewsLast
}
